import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";

import { Box } from "@mui/system";
import React, { useEffect } from "react";
import "./Registration.css";
import { useDispatch } from "react-redux";
import { unsetAccount } from "../../features/registration/registrationSlice";
import { auth } from "../../utils/firebase/firebase"
import { signOut } from "firebase/auth";

function Success() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
        const user = auth.currentUser;
        // console.log(user)
  },[])

  const handleClick = async (e) => {
    dispatch(unsetAccount())
    await signOut(auth);
    navigate("/login");
  };

  return (
    <Box className="card">
      <Box className="card card--container">
        <Box className="card">
          <h1 className="success__title">Account Creation Completed</h1>
          <p className="success__text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur.
          </p>
          <Button
            variant="contained"
            className="success__button"
            onClick={handleClick}
          >
            Proceed to Log In
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default Success;
